import { FC, PropsWithChildren } from 'react';

import { useCollectionsStatusStore } from '@/shared/lib/sj-orm/stores/collectionsStatus.store';

import { MigrationErrorLockScreen } from './MigrationErrorLockScreen';

export const MigrationErrorLockScreenProvider: FC<PropsWithChildren> = ({ children }) => {
  const isMigrationError = useCollectionsStatusStore((s) => s.isMigrationError);

  if (isMigrationError) {
    return <MigrationErrorLockScreen />;
  }

  return children;
};
